// Storage.js
const storeToken = (token) => {
  try {
    window.localStorage.setItem("token", token);
  } catch (error) {
    console.log("Error getting in store token!", error);
  }
};

const getToken = () => {
  try {
    return window.localStorage.getItem("token");
  } catch (error) {
    console.log("Error getting in token", error);
  }
};

export { storeToken, getToken };
